import { defineMessages } from 'react-intl';

import { SelectConfiguredOption } from '@app/hooks';

const requestsMessages = defineMessages({
  resultCount: {
    id: 'resultCount.numberOfRequests',
    defaultMessage: 'Number of requests: <b>{count}</b>',
  },
  showMoreButtonTitle: {
    id: 'requests.showMoreButtonTitle',
    defaultMessage: 'Show more requests',
  },
  noTabResults: {
    id: 'requests.noTabResults',
    defaultMessage: 'You currently have no requests.',
  },
  promptTitle: {
    id: 'requests.promptTitle',
    defaultMessage: 'Place request on items by signing into your account.',
  },
});

const holdsMessages = defineMessages({
  resultCount: {
    id: 'resultCount.numberOfHolds',
    defaultMessage: 'Number of holds: <b>{count}</b>',
  },
  showMoreButtonTitle: {
    id: 'holds.showMoreButtonTitle',
    defaultMessage: 'Show more holds',
  },
  noTabResults: {
    id: 'holds.noTabResults',
    defaultMessage: 'You currently have no holds.',
  },
  promptTitle: {
    id: 'holds.promptTitle',
    defaultMessage: 'Place hold on items by signing into your account.',
  },
});

const loansMessages = defineMessages({
  resultCount: {
    id: 'resultCount.numberOfLoans',
    defaultMessage: 'Number of loans: <b>{count}</b>',
  },
  showMoreButtonTitle: {
    id: 'loans.showMoreButtonTitle',
    defaultMessage: 'Show more loans',
  },
  noTabResults: {
    id: 'loans.noTabResults',
    defaultMessage: 'You currently have no loans.',
  },
  promptTitle: {
    id: 'loans.promptTitle',
    defaultMessage: 'See your loans by signing into your account.',
  },
});

const checkoutsMessages = defineMessages({
  resultCount: {
    id: 'resultCount.numberOfCheckouts',
    defaultMessage: 'Number of checkouts: <b>{count}</b>',
  },
  showMoreButtonTitle: {
    id: 'checkouts.showMoreButtonTitle',
    defaultMessage: 'Show more checkouts',
  },
  noTabResults: {
    id: 'checkouts.noTabResults',
    defaultMessage: 'You currently have no checkouts.',
  },
  promptTitle: {
    id: 'checkouts.promptTitle',
    defaultMessage: 'See your checkouts by signing into your account.',
  },
});

const feesMessages = defineMessages({
  resultCount: {
    id: 'resultCount.numberOfFees',
    defaultMessage: 'Number of fees: <b>{count}</b>',
  },
  showMoreButtonTitle: {
    id: 'fees.showMoreButtonTitle',
    defaultMessage: 'Show more fees',
  },
  noTabResults: {
    id: 'fees.noTabResults',
    defaultMessage: 'You currently have no fees.',
  },
  promptTitle: {
    id: 'fees.promptTitle',
    defaultMessage: 'View your fees by signing into your account.',
  },
});

export const getTabMessages = (
  selectConfiguredOption: SelectConfiguredOption
) => ({
  holds: selectConfiguredOption(requestsMessages, holdsMessages),
  checkouts: selectConfiguredOption(loansMessages, checkoutsMessages),
  fees: feesMessages,
});
